<template>
    <a-card :bordered="false" :loading="loading.page" v-if="loading.page">
      Loading
    </a-card>
    <div v-else>
      <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
            <a-card :loading="loading.page" class="margin-bottom">
              
              <div slot="title">
                <h4 class="margin-remove">Kewajiban AP Manifest</h4>
                <small>{{ data_header ? data_header.no_kewajiban_ap : null }}</small>
              </div>

              <!-- header section -->
              <a-popover v-if="getAuth.divisi[0] == 'Keuangan'" slot="extra" trigger="click" placement="bottom">
                <span slot="title">Select Action</span>
                <ul class="m-list-wrapper bordered" slot="content">
                  <li>
                    <a-button-group style="display: flex; flex-direction: column; gap: 8px;">
                      <a-button
                      :disabled="data_header.last_status !== 'Revised'"
                      style="width: 100%;"
                      type="dashed"
                      icon="edit"
                      @click="navigateTo('revise', data_header.kewajiban_ap_id)"
                      >Edit</a-button>

                      <a-button
                      v-if="getAuth.username == data_header.tlc_create && is_allow_cancel && data_header.cancel_sts == '0'"
                      style="width: 100%;"
                      type="danger"
                      icon="close-square"
                      :loading="loading.cancel"
                      @click="cancelTransaction"
                      >Cancel</a-button
                      >
                    </a-button-group>
                  </li>
                </ul>
                <a-button icon="more">Action</a-button>
              </a-popover>

              <!-- content section -->
              <div class="m-card-body">
                <a-row>
                  <a-col span="12">
                    <ul class="m-list-wrapper bordered">
                      <li>
                        <span class="m-list-title" >Date / TLC</span>
                        <span class="m-list-desc">{{ moment(data_header.create_dt).format("YYYY-MM-DD") + ' / ' + data_header.tlc_create }}</span>
                      </li>

                      <li>
                        <span class="m-list-title" >Tanggal Kewajiban</span>
                        <span class="m-list-desc">{{ moment(data_header.tgl_kewajiban).format("YYYY-MM-DD") }}</span>
                      </li>
                      
                      <li>
                        <span class="m-list-title" >Description</span>
                        <span class="m-list-desc">{{ data_header.note }}</span>
                      </li>

                      <li>
                        <span class="m-list-title" >Nilai AP</span>
                        <span class="m-list-desc">{{ customFormatCurrency(data_header.currency, total_payment + total_tax) }}</span>
                      </li>
                      <li>
                        <span class="m-list-title">Nilai Kurs IDR</span>
                        <span class="m-list-desc">{{ customFormatCurrency('IDR', data_header.kurs_idr) }}</span>
                      </li>
                    </ul>
                  </a-col>
                  <a-col sapn="12">
                    <ul class="m-list-wrapper bordered">
                      <li>
                        <span class="m-list-title">Beneficiary</span>
                        <span class="m-list-desc">{{ data_header.beneficiary }}</span>
                      </li>

                      <li>
                        <span class="m-list-title">No. Invoice</span>
                        <span class="m-list-desc">{{ data_header.no_invoice }}</span>
                      </li>

                      <li>
                        <span class="m-list-title">Cost Center</span>
                        <span class="m-list-desc">{{ data_header.cost_center_kode }}</span>
                      </li>

                      <li>
                        <span class="m-list-title">Item Anggaran</span>
                        <span class="m-list-desc">{{ data_header.kode_anggaran }} - {{ data_header.item_anggaran }}</span>
                      </li>
                      <li>
                        <span class="m-list-title">User CC / No CC</span>
                        <span class="m-list-desc">{{ data_header.user_cc }} - {{ data_header.no_cc }}</span>
                      </li>

                    </ul>
                  </a-col>
                </a-row>
              </div>
            </a-card>

            <a-collapse v-if="!getScreen" class="margin-top" activeKey="1">
              <a-collapse-panel key="1">
                <h4 slot="header" class="margin-remove">Detail AP Kewajiban</h4>

                <a-card>
                  <a-input-search
                    v-model="search_detail"
                    style="width: 50%"
                    placeholder="Quick Search"
                    allowClear
                  />
                </a-card>

                <a-table
                  :columns="columns_detail"
                  :dataSource="filteredDataDetails"
                  :pagination="pagination"
                  size="small"
                  bordered
                  :loading="loading.detail"
                  :scroll="{ x: 'max-content' }"
                >
                  <template slot="no" slot-scope="text, item, index">
                    {{ index +1 }}
                  </template>
                  <template slot="no_detail" slot-scope="text, item">
                    {{ item.no_rencana_byr }}
                  </template>

                  <template slot="item_name" slot-scope="text, item">
                    <div>
                      <p style="margin-bottom: 0;">
                        {{ item.nama_item }}
                        <span
                          v-if="item.type_tax !== 'non_tax'"
                          class="tax-label"
                        >
                          - ({{ findTax(item.type_tax) }})
                        </span>
                      </p>
                      <p style="margin-bottom: 0; margin-top: 0; font-style: italic; font-size: 11px;">
                        ({{ item.type_tax == 'non_tax' ? 'Non Tax' : 'Tax' }})
                      </p>
                    </div>
                  </template>

                  <template slot="payment_date" slot-scope="text, item">
                    {{ moment(item.tanggal_byr).format("YYYY-MM-DD") }}
                  </template>

                  <template slot="payment_value" slot-scope="text, item">
                    {{ customFormatCurrency(data_header.currency, item.nilai_bayar) }}
                  </template>
                  <template slot="actions" slot-scope="text, item">
                    <a-button v-if="item.type_tax !== 'non_tax'" icon="edit" :type="item.is_editable == '1' ? 'danger' : 'primary'" @click="showModalTax(item)"></a-button>
                  </template>
                </a-table>

                <div class="table-note">
                    <i>*PPH tidak diperhitungkan</i>
                  </div>

                <div class="table-footer">
                  <a-divider />
                  <div class="footer-row footer-grand">
                    <span class="footer-label">Grand Total</span>
                    <span class="footer-separator">:</span>
                    <span class="footer-value">
                      {{ customFormatCurrency(data_header.currency, total_payment + total_tax) }}
                    </span>
                  </div>
                </div>

              </a-collapse-panel>
            </a-collapse>

            <!-- manifest approval section -->
            <a-card class="margin-top"
            title="Manifest Actions"
            v-if="actor !== 'Creator' && data_actions.length > 0 && data_header.cancel_sts == '0'"
            >
              <template>
                <a-form :form="form">
                  <a-form-item label="Note">
                    <a-textarea
                      placeholder="Write the note here ... "
                      :rows="4"
                      v-decorator="['note']"
                    />
                  </a-form-item>
                  <a-form-item label="Aksi">
                    <a-select
                      showSearch
                      v-decorator="[
                        'status',
                        {
                          rules: [{ required: true }]
                        },
                      ]"
                    >
                      <a-select-option v-for="item in data_actions" :key="item">{{
                        item
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-form>
                <template class="ant-card-actions" slot="actions">
                  <a-button
                  @click="approval"
                  block
                  type="primary"
                  html-type="submit"
                  :loading="loading.approval"
                  >Save</a-button
                  >
                </template>
              </template>
            </a-card>
          </a-col>

          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-card :loading="loading.page" :class="getScreen ? 'margin-top' : ''">
              <div slot="title">Required Document</div>

              <a-alert
                v-if="files.length === 0"
                type="error"
                message="No document was uploaded!"
                banner
              />

              <a-list
                v-else
                itemLayout="horizontal"
                :dataSource="files"
              >
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title" class="m-display-flex space-between">
                      <h3 class="margin-remove">
                        <a-icon
                          type="file-text"
                          class="margin-right-small"
                        />
                        {{ item.file_doc }}
                      </h3>

                      <a-button
                        @click="fileHandler(item.file_doc_id, item.file_doc)"
                        size="small"
                        type="default"
                        icon="eye"
                        :loading="loading.doc"
                      >
                        View
                      </a-button>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-card>

            <a-collapse class="margin-top" activeKey="1">
              <a-collapse-panel key="1">
                <div class="m-display-flex space-between align-middle" slot="header">
                  <h4 class="margin-remove">Status</h4>
                  <div>
                    <Status :status="lastStatus(data_header.last_status)" />
                    <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                    >
                      History
                      <a-icon type="undo" />
                    </a-button>
                  </div>
                </div>

                <a-timeline class="m-timeline">
                  <a-timeline-item color="green">
                    <div class="m-timeline-title">
                      Pembuat - {{ data_header.tlc_create }}
                    </div>
                    <div class="m-timeline-body">
                      <h4 class="margin-remove">{{ data_header.cancel_sts == '1' ? data_header.cancel_dt : moment(data_header.create_dt).format("DD-MM-YYYY") }}</h4>
                    </div>
                    <div class="m-timeline-footer">
                      <a-tag :color="data_header.cancel_sts == '1' ? 'red' : 'green' ">{{data_header.cancel_sts == '1' ? 'Canceled' : 'Created'}}</a-tag>
                    </div>
                  </a-timeline-item>
                  <a-timeline-item
                    v-for="workflow in data_statuses"
                    :key="workflow.step_no"
                    :color="
                      workflow.status === 'On Process' ||
                      workflow.status === 'Delivered'
                        ? 'red'
                        : workflow.status === 'Waiting'
                        ? 'grey'
                        : 'green'
                    "
                  >
                    <div class="m-timeline-title">
                      {{ workflow.actor }}
                      {{ workflow.tlc ? " - " + workflow.tlc : "" }}
                    </div>
                    <div class="m-timeline-body">
                      <h4
                        class="margin-remove"
                        v-if="workflow.tanggal_aksi !== null"
                      >
                        {{ workflow.tanggal_aksi }}
                      </h4>
                      <span class="m-text-small" v-if="workflow.remark">{{
                        workflow.remark
                      }}</span>
                      <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                    </div>
                    <div class="m-timeline-footer">
                      <Status :status="workflow.status" />
                    </div>
                  </a-timeline-item>
                </a-timeline>
              </a-collapse-panel>
            </a-collapse>

            <a-collapse class="margin-top" activeKey="1">
              <a-collapse-panel key="1">
                <div
                  class="m-display-flex space-between align-middle"
                  slot="header"
                >
                  <h4 class="margin-remove">Related Document</h4>
                </div>

                <a-list
                  itemLayout="horizontal"
                  :dataSource="related_list"
                >
                  <Empty v-if="related_list.lenght <= 0"/>
                  <a-list-item slot="renderItem" slot-scope="item">
                    <a-list-item-meta>
                      <div
                        slot="title"
                        class="m-display-flex space-between align-middle"
                      >
                        <a @click="navigateTo('manifest_np', item.kewajiban_id, item)"
                          >{{ item.header }} | {{ item.tlc_create }}</a
                        >
                        <Status
                          :class="!getScreen ? 'margin-remove' : ''"
                          :status="item.last_status"
                        />
                      </div>
                      <div
                        slot="title"
                        class="m-display-flex space-between align-middle"
                        v-if="item.no_kewajiban"
                      >
                        <span>{{ item.no_kewajiban }}</span>
                      </div>
                      <div slot="description">
                        <div class="m-width-full">
                          <a-tooltip
                            class="ant-tooltip-inner"
                            placement="top"
                            :title="
                              item.description
                                ? item.description
                                : 'Tidak ada deskripsi'
                            "
                          >
                            <span class="ant-description-ellipses">{{
                              item.description
                                ? item.description
                                : "Tidak ada deskripsi"
                            }}</span>
                          </a-tooltip>
                        </div>
                      </div>
                      <div slot="title" v-if="item.nilai">
                        <span class="m-timeline-title">{{
                          formatCurrency(item.currency, item.nilai)
                        }}</span>
                      </div>
                    </a-list-item-meta>
                  </a-list-item>
                </a-list>
              </a-collapse-panel>
            </a-collapse>

          </a-col>

        </a-row>
      </div>

      <a-modal :visible="modal_tax" @cancel="modalOnClose" :maskClosable="false" width="50%" :centered="true">
        <span slot="title"> <a-icon type="reconciliation" />&nbsp;Tax Deposit Entry</span>

        <a-form :form="formTax">
          <a-row :gutter="8">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="Tax Type">
                <a-select v-decorator="['tax_type', { rules: [{ required: true }], initialValue: this.tax_edit_state.type_tax }]" disabled>
                  <a-select-option v-for="item in getType_tax" :key="item.value" :value="item.value">
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="Tax Deposit">
                <a-select
                  v-decorator="['tax_deposit', { rules: [{ required: true }], initialValue: this.tax_edit_state.id_setoran_pajak }]"
                  option-filter-prop="children" :filter-option="filterOption" showSearch>
                  <a-select-option v-for="item in list_tax_deposit_filtered" :key="item.value" :value="item.value"
                    :text="item.text">
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="Tax Object" v-if="!(this.tax_edit_state.type_tax == 'pph_21' || this.tax_edit_state.type_tax == 'ppn')">
                <a-select v-decorator="['tax_object', { rules: [{ required: false }], initialValue: this.tax_edit_state.id_objek_pajak }]"
                  option-filter-prop="children" :filter-option="filterOption" showSearch allowClear>
                  <a-select-option v-for="item in list_tax_object_filtered" :key="item.value" :value="item.value" :text="item.text">
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="DPP Value">
                <a-input-number class="m-width-full m-text-align-right"
                  :formatter="(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')" 
                  :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-decorator="['dpp_value', { rules: [{ required: true, message: 'DPP value is required' }, { validator: validateValue('DPP Value') }], initialValue: this.tax_edit_state.value_dpp },]" />
              </a-form-item>

              <a-form-item label="Tax Value">
                <a-input-number class="m-width-full m-text-align-right"
                  v-on:keydown.enter.prevent="preventEnterButton" :formatter="(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')" 
                  :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-decorator="['value',{ rules: [{ required: true, message: 'Tax value is required' }, { validator: validateValue('Tax Value') }], initialValue: this.tax_edit_state.value_tax },]" 
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>

        <template slot="footer">
          <a-button @click="onSubmitTax" block type="primary" html-type="submit" :loading="loading.save_tax">Save</a-button>
        </template>
      </a-modal>
    </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  props: ['id'],
  mixins: [CurrencyFormat],
  data(){
    const columns_detail = [
      {
        title: "No.",
        key: "no",
        width: 60,
        align: "center",
        scopedSlots: { customRender: "no" },
      },
      {
        title: "No. Detail",
        key: "no_detail",
        align: "center",
        scopedSlots: { customRender: "no_detail" },
      },
      {
        title: "Nama Item",
        key: "item_name",
        dataIndex: "nama_item",
        scopedSlots: { customRender: "item_name" },
      },
      {
        title: "Nilai Bayar",
        key: "payment_value",
        align: "right",
        scopedSlots: { customRender: "payment_value" },
      },
    ];

    const columns_tax = [
      {
        title: "No.",
        key: "no",
        align: "center",
        scopedSlots: { customRender: "no" },
      },
      {
        title: "Tax Date",
        key: "tax_date",
        align: "center",
        scopedSlots: { customRender: "tax_date" },
      },
      {
        title: "Type Tax",
        key: "type_tax",
        align: "center",
        scopedSlots: { customRender: "type_tax" },
      },
      {
        title: "Tax Deposit",
        key: "tax_deposit",
        align: "center",
        scopedSlots: { customRender: "tax_deposit" },
      },
      {
        title: "Tax Object",
        key: "tax_object",
        align: "center",
        scopedSlots: { customRender: "tax_object" },
      },
      {
        title: "Value DPP",
        key: "value_dpp",
        align: "center",
        scopedSlots: { customRender: "value_dpp" },
      },
      {
        title: "Value Tax",
        key: "value_tax",
        align: "center",
        scopedSlots: { customRender: "value_tax" },
      },
    ];

    return {
      moment,
      loading: {
        page: false,
        doc: false,
        approval: false,
        cancel: false,
        save_tax: false,
        detail: false
      },
      data_header: {},
      data_details: [],
      data_statuses: [],
      data_actions: [],
      data_taxes: [],
      pagination: {},
      columns_detail,
      columns_tax,
      actor: "",
      modal_tax: false,
      search_detail: "",
      is_allow_cancel: false,
      tax_edit_state: {},
      list_tax_deposit: [],
      list_tax_object: [],
      list_tax_deposit_filtered: [],
      list_tax_object_filtered: [],
      actor_as: '',
      related_list: []
    }
  },

  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getIsSpecialMenu",
      "getDateTimeFormat",
      "getStandartFormatDate",
      "getDateTimeStandartFormat",
      "getType_tax",
    ]),

    files() {
      return [
        {
          file_doc_id: this.data_header.kewajiban_ap_id,
          file_doc: this.data_header.file_doc_support
        }
      ]
    },

    filteredDataDetails() {
      if (!this.search_detail) return this.data_details;

      const keyword = this.search_detail.toLowerCase().trim();

      return this.data_details.filter(item => {
        return (
          String(item.no_rencana_byr || '').toLowerCase().includes(keyword) ||
          String(item.nama_item || '').toLowerCase().includes(keyword) ||
          String(item.type_tax || '').toLowerCase().includes(keyword) ||
          String(item.tanggal_byr || '').toLowerCase().includes(keyword)
        );
      });
    },

    total_payment(){
      return this.data_details.reduce((total, item) => {
        if(item.type_tax == 'non_tax'){
          return total + Number(item.nilai_bayar || 0)
        }
        return total;
      }, 0)
    },

    total_tax(){
      return this.data_details.reduce((total, item) => {
        const type = String(item.type_tax || '').toLowerCase();

        if(type.includes('ppn')){
          return total + Number(item.nilai_bayar || 0)
        }
        return total;
      }, 0)
    },

    total_pph() {
      return this.data_details.reduce((total, item) => {
        const type = String(item.type_tax || '').toLowerCase();

        if (!type.includes('ppn') && type !== 'non_tax') {
          return total + Number(item.nilai_bayar || 0);
        }

        return total;
      }, 0);
    },
  },

  beforeCreate(){
    this.form = this.$form.createForm(this);
    this.formTax = this.$form.createForm(this);
  },
  
  
  created(){
    this.fetchData()
    this.$store.dispatch("Fetch_TYPE_TAX");
  },

  methods: {
    async fetchData(){
      try {
        this.loading.page = true
        const response = await axios({
          method: "GET",
          url: this.$serviceUrl + `account_pay_kewajiban/manifest`,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
          params: {
            manifest_id: this.id
          }
        })

        if(response.data){
          this.data_header = response.data.data
          this.data_details = response.data.detail
          this.data_statuses = response.data.statuses
          this.data_taxes = response.data.taxes
          this.data_actions = response.data.action
          this.actor = response.data.actor_as
          this.is_allow_cancel = response.data.allow_cancel
          this.list_tax_deposit = response.data.setoran_pajak
          this.list_tax_object = response.data.objek_pajak
          this.actor_as = response.data.actor_as
          this.related_list = response.data.related
        }

        if (this.actor == 'Tax Officer' && (this.data_header.last_status !== 'Rejected' && this.data_header.cancel_sts !== '1')) {
          const payload = {
            title: "Actions",
            width: 100,
            align: "center",
            fixed: "right",
            scopedSlots: { customRender: "actions" },
          }

          const exists = this.columns_detail.some(
            item => item.title === 'Actions'
          )

          if (!exists) {
            this.columns_detail.push(payload)
          }
        }

        this.loading.page = false

      } catch (error) {
        this.loading.page = false
        console.log(error);
        
      }
    },

    async fileHandler(id, fileName){
      try {
        this.loading.doc = true
        const response = await axios({
          method: "GET",
          url: this.$serviceUrl + `account_pay_kewajiban/file/${id}`,
          responseType: "blob",
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          }
        })

        this.loading.doc = false

        const blob = response.data;
        const mimeType = blob.type;
        const url = window.URL.createObjectURL(blob);

        // PDF atau gambar -> buka tab baru
        if (
          mimeType === "application/pdf" ||
          mimeType.startsWith("image/")
        ) {
          window.open(url, "_blank");
          return;
        }

        const link = document.createElement("a");
        link.href = url;

        const disposition = response.headers["content-disposition"];
        let filename = fileName;

        if (disposition) {
          const match = disposition.match(/filename="?(.+?)"?$/);
          if (match) {
            filename = match[1];
          }
        }

        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(url);

      } catch (error) {
        console.log(error.response);
        this.loading.doc = false
        this.displayMessageValue("error-other", 'Physical file not found.');
      }
    },

    approval(){
      this.loading.approval = true
      this.form.validateFields(async (err, values) => {
        if(err){
          this.loading.approval = false
          return
        }

        try {
          const payload = {
            note: values.note ? values.note : "",
            manifest_id: this.id,
            status: values.status
          }

          if (this.actor_as == 'Tax Officer' && values.status == 'Verify') {
            const hasTaxNotEntry = this.filteredDataDetails.some( item => item.is_editable == '1');
            if (hasTaxNotEntry) {
              this.displayMessageValue("error-other", "Tax data has not been entered. Please enter the tax data before continuing.");
              this.loading.approval = false
              return;
            }
          }

          const response = await axios({
            method: "POST",
            url: this.$serviceUrl + `account_pay_kewajiban/approval`,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey,
            },
            data: payload
          })
          this.displayMessageValue("success-other", response.data.message);
          this.fetchData()
          this.loading.approval = false
        } catch (error) {
          this.loading.approval = false
          console.log(error);
        }
      })
    },

    async cancelTransaction(){
      try {
        this.loading.cancel = true
        const payload = {
          manifest_id: this.id
        }
        const response = await axios({
          method: "POST",
          url: this.$serviceUrl + `account_pay_kewajiban/cancel`,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
          data: payload
        })
        this.displayMessageValue("success-other", response.data.message);
        this.fetchData()
        this.loading.cancel = false

      } catch (error) {
        this.loading.cancel = false
        console.log(error.response.data);
        this.displayMessageValue("error-other", error.response.data.message);
      }
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },

    historyToggle(e) {
      e.stopPropagation();
    },

    showModalTax(val){
      this.tax_edit_state = val
      this.modal_tax = true

      const filterDeposit = this.list_tax_deposit.filter((e) => e.id_type_tax == val.type_tax)
      if(filterDeposit){
        this.list_tax_deposit_filtered = filterDeposit
      }

      const filterObject = this.list_tax_object.filter((e) => e.id_type_tax == val.type_tax)
      if(filterObject){
        this.list_tax_object_filtered = filterObject
      }
    },

    modalOnClose(){
      this.modal_tax = false
      this.formTax.resetFields();
    },

    navigateTo(name, id='', payload=null){
      if(name == 'create'){
        this.$router.push({name: 'ap_kewajiban_create'})
      } else if (name == 'manifest'){
        this.$router.push({
          name: 'ap_kewajiban_manifest',
          params: {
            id: id
          }
        })
      } else if(name == 'create_ap_np'){
        this.$store.dispatch('setSelectedReminder', payload)

        this.$router.push({name: 'ap_kewajiban_create'})
      } else if (name == 'manifest_np'){
        const route = this.$router.resolve({
          name: 'ap_kewajiban_need_process_manifest',
          params: {
            id: id
          }
        })

        window.open(route.href, '_blank')
      } else if (name == 'revise'){
        localStorage.removeItem("np_id")
        this.$store.dispatch('setSelectedReminder', null)
        
        this.$router.push({
          name: 'ap_kewajiban_edit',
          params: {
            id: id
          }
        })
      }
    },

    findTax(item){
      const find = this.getType_tax.find((e) => e.value == item);
      if(find){
        return find.text
      } else return ""
    },

    validateValue(fieldName, min = 0) {
      return (rule, value, callback) => {
        // biarkan rule required yang menangani value kosong
        if (value === undefined || value === null || value === '') {
          callback();
          return;
        }

        if (Number(value) <= min) {
          callback(new Error(`${fieldName} must be greater than ${min}.`));
          return;
        }

        callback();
      };
    },

    async onSubmitTax(){
      this.loading.save_tax = true
      this.loading.detail = true
      this.formTax.validateFields( async (error, values) => {
        if(error){
          this.loading.save_tax = false
          this.loading.detail = false
          return
        } 

        try {
          console.log(this.tax_edit_state);
          
          const payload = {
            manifest_id: this.id,
            id_tax_transaction: this.tax_edit_state.id_tax_transaction,
            type_tax: values.tax_type,
            tax_deposit: values.tax_deposit,
            tax_object: values.tax_object ? values.tax_object : null,
            dpp_value: values.dpp_value,
            tax_value: values.value,
            id_transaction: this.tax_edit_state.kewajiban_ap_id,
            id_dtl_transaction: this.tax_edit_state.kewajiban_ap_dtl_id,
            tax_date: this.tax_edit_state.create_dt,
            item_name: this.tax_edit_state.nama_item
          }
          
          const response = await axios({
            method: "POST",
            url: this.$serviceUrl + 'account_pay_kewajiban/tax_entry',
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey,
            },
            data: payload
          })
          
          if(response){
            this.data_details = response.data.data
          }
          this.loading.save_tax = false
          this.loading.detail = false
          this.modalOnClose()
          this.displayMessageValue("success-other", response.data.message)
        } catch (error) {
          console.log(error.response);
          
          this.loading.save_tax = false
          this.loading.detail = false
          this.displayMessageValue("error-other", error.response.data.message);
          
        }
      })
    },

    lastStatus(val){
      if(this.data_header.cancel_sts == '1') return 'Canceled'
      else if(val == 'Delivered') return 'On Process'
      else return val
    }

  }
}
</script>

<style>
.tax-label {
  font-weight: bold;
  font-style: italic;
}

.footer-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.footer-row:last-child {
  margin-bottom: 0;
}

.footer-label {
  width: 120px; /* Biar ":" sejajar */
  font-weight: 600;
}

.footer-separator {
  width: 20px;
  text-align: center;
}

.footer-value {
  flex: 1;
  text-align: right; /* Mentok kanan */
  font-weight: 600;
}

.table-note {
  margin-top: -50px;
  padding: 10px;
  font-size: 0.75rem;
}
</style>